// services/LabTestApi/PopularTest.js
import axios from "axios";

// ✅ Sirf .env se URL lega, koi fallback nahi
const API_BASE_URL = process.env.REACT_APP_API_URL;
const BASE_URL = `${API_BASE_URL}Lab`;

export const getAllTests = async (pageNumber = 1, pageSize = 50) => {
  try {
    const res = await axios.get(
      `${BASE_URL}/GetTestAll?pageNumber=${pageNumber}&pageSize=${pageSize}`
    );

    console.log("📦 FULL API RESPONSE:", res.data);

    // ✅ ALWAYS RETURN OBJECT (not array)
    return res.data;
  } catch (err) {
    console.error("❌ API ERROR:", err);
    return { data: [] };
  }
};